<!--CardTool:制卡操作栏 2024/04/02 16:04:42 YuAng-->

<template>
  <div class="card-tool">
    <span v-if="isAdmin" class="span-blue-btn" @click="editCard">编辑</span>
    <span v-if="item.templateType !== 'THIRD_SHEET'" class="span-blue-btn" @click="downloadCardAction">下载</span>
    <el-popover v-if="isAdmin" v-model="visible" width="40px" trigger="hover" popper-class="yj-popover-more">
      <div class="yj-popover-actions">
        <p v-if="!item.examId" @click="openDialog('update')">修改</p>
        <p v-if="isShowCopy" @click="openDialog('copy')">复制</p>
        <p @click="openDialog('delete')">删除</p>
      </div>
      <p slot="reference" class="exam-more">
        <span class="span-blue-btn more">
          更多<i :class="'el-icon-arrow-' + (visible ? 'up' : 'down')"></i>
        </span>
      </p>
    </el-popover>
    <template v-else>
      <span v-if="isShowCopy" class="span-blue-btn more" @click="openDialog('copy')">复制</span>
    </template>
    <!-- 更多操作模态窗 -->
    <yue-dialog :title="dialogTitle" :visible.sync="dialog.visible" width="500px" append-to-body>
      <div class="dialog-body">
        <p v-if="dialog.type === 'delete'" class="dialog-body-content">
          <span v-if="item.creatorId == userInfo.userId">答题卡模板删除后不可恢复，是否确认删除？</span>
          <span v-else>当前答题卡模板并非本人创建，删除后不可恢复,是否确认删除？</span>
        </p>
        <p v-else-if="dialog.type === 'download'" class="dialog-body-content">
          <span>该答题卡已下载，不可编辑，是否复制为新卡进行编辑？</span>
        </p>
        <el-form v-else label-width="82px" class="print-form" size="small">
          <el-form-item label="模板名称：" required>
            <el-input v-model="form.templateName" :placeholder="item.templateName + '模板'"></el-input>
          </el-form-item>
          <template v-if="dialog.type === 'update'">
            <el-form-item label="所属年级：" required :key="item.id">
              <el-select v-model="form.grade" style="width: 100%" placeholder="请选择年级">
                <el-option v-for="(grade, index) in xGradeList" :key="'grade' + index" :label="grade.gradeName" :value="grade.gradeNum"></el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-form>
        <p class="dialog-body-footer">
          <el-button type="primary" size="mini" @click="dialog.okAction" :loading="loading">确定</el-button>
          <el-button size="mini" plain @click="dialog.visible = false">取消</el-button>
        </p>
      </div>
    </yue-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { cardApi } from '@/v3/modules/card/utils/api'
import util from '@/v2/utils/util'
export default {
  name: 'CardTool',
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      visible: false,
      dialog: {
        type: 'copy',
        visible: false,
        okAction: () => { }
      },
      form: {
        templateName: '',
        grade: '',
        subject: ''
      },
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      gradeList: 'getGradeList'
    }),
    isAdmin: function () {
      let roles = this.userInfo.roles
      let isJz = false
      if (roles) {
        // 是否是教育局长
        isJz = roles.find(item => item.roleCode === '718071702')
      }
      return this.userInfo.isAdmin || isJz || this.item.creatorId === this.userInfo.userId
    },
    dialogTitle: function () {
      let title = '答题卡模板'
      if (this.dialog.type === 'copy') {
        title += '复制'
      } else if (this.dialog.type === 'update') {
        title += '修改'
      } else if (this.dialog.type === 'delete') {
        title += '删除'
      }
      return title
    },
    xGradeList () {
      const list = this.gradeList
      // 限制是同学段的年级列表
      const target = list.find(item => item.gradeNum === this.item.grade)
      if (target) {
        return list.filter(item => item.stage === target.stage)
      }
      return list
    },
    isShowCopy () {
      // 区域的v1版本模板不显示复制按钮
      return !(this.$store.state.v2.loginPlatform === 'region' && this.item.version === 'V1')
    }
  },
  methods: {
    editCard () {
      this.loading = true
      const isOldVersion = this.item.version === 'V1'
      if (this.item.examId) { // 已使用，则跳转“答题卡设置标准答案”的页面
        this.$router.push('/exam/single/answer-new/' + this.item.examId)
      } else if (this.item.templateType === 'THIRD_SHEET') {
        // 第三方制卡，统一跳转新的切题页面
        this.$router.push('/v2/card/third-multiple/cut?id=' + this.item.id)
      } else { // 未使用，其他则默认跳转普通制卡的“制卡工具编辑”的页面
        // 判断是否已下载过
        if (this.item.downloadCount > 0) {
          // 已下载过
          this.openDialog('download')
          return
        }
        let path = isOldVersion ? '/card/create' : '/v2/card/cardeditor/card'
        const route = {
          path: path,
          query: {
            istemplate: 1,
            isEdit: 1,
            grade: this.item.grade,
            subjectCode: this.item.subjectCode,
            examSheetId: this.item.id
          }
        }
        // 如果是组卷制卡，跳转组卷制卡的“制卡工具编辑”的页面
        if (this.item.paperSnapshotId) {
          route.path = this.item.version === 'V1' ? '/card/zujuan' : '/v2/card/cardeditor/card'
          route.query.paperSnapshotId = this.item.paperSnapshotId
        }
        this.$router.push(route)
      }
    },
    async downloadCardAction () {
      // 组卷制卡，下载的是答题卡和原卷的一个压缩包
      const params = {
        id: this.item.id,
        version: this.item.version
      }
      cardApi.downloadCard(params).then(resp => {
        if (resp.success) {
          const { url, type, fileName } = resp.body
          if (params.version !== 'V1') {
            this.item.downloadCount = 1
            this.$emit('change', this.item)
          }
          util.download(url, fileName + '.' + type)
        } else {
          this.$message.error(resp.message || '下载失败')
        }
      })
    },
    openDialog (type) {
      this.visible = false
      this.loading = false
      this.dialog.type = type
      this.dialog.okAction = this[type + 'Card']
      const { templateName, grade } = this.item
      this.form = { templateName: templateName + (type === 'copy' ? '副本' : ''), grade }
      this.dialog.visible = true
    },
    updateCard () {
      if (!this.form.templateName) {
        return this.$message.warning('请设置模板名称')
      } else if (!this.form.grade) {
        return this.$message.warning('请选择年级')
      }
      this.loading = true
      const params = {
        templateId: this.item.id,
        templateName: this.form.templateName,
        grade: this.form.grade,
        version: this.item.version
      }
      cardApi.changeTemplate(params).then(resp => {
        if (resp.success) {
          this.dialog.visible = false
          this.$emit('change', params)
        } else {
          this.$message.error(resp.message || '修改失败')
        }
      })
    },
    copyCard (callback) {
      if (!this.form.templateName) {
        return this.$message.warning('请设置模板名称')
      }
      this.loading = true
      const params = {
        templateId: this.item.id,
        version: this.item.version,
        templateName: this.form.templateName
      }
      cardApi.reuseTemplate(params).then(resp => {
        if (resp.success) {
          this.dialog.visible = false
          this.$emit('change', this.item)
          if (callback) {
            this.item.id = resp.body
            callback()
          }
        } else {
          this.dialog.visible = false
          this.$message.error(resp.message)
        }
      })
    },
    downloadCard () {
      // 下载答题卡-需要走复制答题卡逻辑
      this.loading = true
      this.form.templateName = this.item.templateName + '副本'
      const callback = () => {
        let path = '/v2/card/cardeditor/card'
        const route = {
          path: path, query: {
            istemplate: 1,
            isEdit: 1,
            grade: this.item.grade,
            subjectCode: this.item.subjectCode,
            examSheetId: this.item.id
          }
        }
        // 如果是组卷制卡，跳转组卷制卡的“制卡工具编辑”的页面
        if (this.item.paperSnapshotId) {
          route.query.paperSnapshotId = this.item.paperSnapshotId
        }
        this.$router.push(route)
      }
      this.copyCard(callback)
    },
    deleteCard () {
      this.loading = true
      const params = {
        id: this.item.id,
        version: this.item.version
      }
      cardApi.deleteTemplate(params).then(resp => {
        if (resp.success) {
          this.dialog.visible = false
          this.$emit('change', this.item)
        }
      })
    }
  }
}
</script>

<style scoped>
.card-tool {
  display: flex;
  align-items: center;
  justify-content: center;
}

.span-blue-btn {
  color: #2877ff;
  font-size: 14px;
  cursor: pointer;
  position: relative;
  padding: 0 8px;
  margin-left: 8px;
}

.span-blue-btn::after {
  content: "";
  position: absolute;
  top: 5px;
  right: -5px;
  width: 1px;
  height: 56%;
  background-color: #ddd;
}

.span-blue-btn.more::after,
.span-blue-btn:last-of-type::after {
  display: none;
}

.dialog-body ::v-deep .el-form-item__label {
  padding-right: 0;
  text-align: left;
}
</style>